import { EducationModule } from "@js/components/EducationCourse/eduConfig";
import { postLevel1ModuleCompleteColor } from "@js/educationContent/CairoMummiesContent/eduConstants";
import Ribbon1 from "@js/public/images/Ribbon1.svg";
import {
    lesson0DefaultEndCode,
    lesson0DefaultMiddleCode,
    lesson0DefaultStartCode,
} from "./lesson0";
import StarklingsLogo from "@js/public/images/StarklingsLogo.svg";
import { m7l0Solution } from "./lesson0Solution";

export const starklingsBuiltinsConfig: EducationModule = {
    solution: "",
    imgSrc: StarklingsLogo.src,
    moduleInfo: {
        id: 7,
        moduleName: "starklingsBuiltins",
        timeEstimate: "45 min",
        title: "Starklings Builtins",
        description: `Welcome to the intro of Starklings Builtins lessons. Good luck!`,
        moduleComplete: {
            badgeName: "STARKLINGS BUILTINS",
            badgeCaption: "A level 8 Starkling",
            ribbonImgSrc: Ribbon1.src,
            badgeImgSrc: StarklingsLogo.src,
            imgColor: postLevel1ModuleCompleteColor,
            badgeTokenId: 10,
        },
    },
    lessons: [
        {
            timeEstimate: "45 min",
            title: "Builtins00",
            formattedDescription: `
[{"type":"paragraph","children":[{"text":"Solve the starklings Builtins00 lesson by finding the TODO(s) on the right and fixing the script to pass the tests"}]}]            
`,
            hints: [],
            defaultEndCode: lesson0DefaultEndCode,
            defaultStartCode: lesson0DefaultStartCode,
            defaultMiddleCode: lesson0DefaultMiddleCode,
            id: 0,
            solution: m7l0Solution,
        },
    ],
};
